// extracted by mini-css-extract-plugin
module.exports = {"boxTitle":"Person_boxTitle__1Yjl7","root":"Person_root__1XUVM","fields":"Person_fields__2EMBc","expandButton":"Person_expandButton__2FVE8"};